import { Cinema } from "../cinema-module/cinema";
import { getElementPositionInPageContext } from "../utils";
import { createLogger } from "utils/logging";

const log = createLogger("cinema", "storefront");
log.info("Initialize StorefrontCinema");

const root = document.getElementById("ft9_benefit_cinema__root_marker");

const featureOrder = getElementPositionInPageContext(root, "feature-order");
const cinema = new Cinema();

cinema.init(featureOrder);
